import InputField from "../../../atoms/InputField";

const CreateInquilino = () => {
    return (
        <>
            <InputField name="userName" label="Nombre del inquilino" placeholder="Nombre del inquilino" />
            <InputField name="userCellphone" label="Telefono del inquilino" placeholder="Telefono del inquilino" />
            <InputField name="userEmail" label="Correo electrónico del inquilino" placeholder="Correo electrónico del inquilino" />
        </>
    );
};

export default CreateInquilino;